import React from "react";
import {Box, Chip, IconButton, Link, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography} from "@mui/material";
import {FilterAltOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {ContentContainer} from "../components/common/content-container";
import DeliveryProgressChip from "./delivery-progress-chip";

export function DashboardPagination({data, page, size, onPageChange, onSizeChange}) {
    const {t} = useTranslation();
    return <TablePagination component="div" count={data.totalElements} page={page} rowsPerPage={size}
        rowsPerPageOptions={[10, 20, 50]} labelRowsPerPage={t("CourierOrdersPerPage")}
        labelDisplayedRows={({from, to, count}) => t("UserPageRange", {from, to, count})}
        getItemAriaLabel={type => t(type === "next" ? "NextCourierOrdersPage" : "PreviousCourierOrdersPage")}
        onPageChange={(_, value) => onPageChange(value)} onRowsPerPageChange={event => onSizeChange(Number(event.target.value))}/>;
}

export function DashboardOrders({data, onDetails, onFilterCourier, ...pagination}) {
    const {t, i18n} = useTranslation();
    return <ContentContainer>
        <Typography variant="h6" sx={{p: 2}}>{t("CourierDashboardOrders")}</Typography>
        {!data.content.length ? <Typography sx={{p: 2}}>{t("CourierDashboardEmpty")}</Typography> :
            <TableContainer><Table size="small" aria-label={t("CourierDashboardOrders")}>
                <TableHead><TableRow>{["OrderNumber", "CourierUser", "Pharmacy", "CourierDeliveryProgressTitle", "OrderDate", "Quantity", "TotalAmount"]
                    .map(key => <TableCell key={key}>{t(key)}</TableCell>)}</TableRow></TableHead>
                <TableBody>{data.content.map(order => <TableRow key={`${order.pharmacyId}:${order.orderNumber}:${order.courierProfileId}`}>
                    <TableCell>{order.orderNumber}</TableCell>
                    <TableCell><Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                        <Link component="button" onClick={() => onDetails(order.courierProfileId)}>{order.courierName}</Link>
                        <Tooltip title={t("CourierDashboardFilter")}>
                            <IconButton size="small" aria-label={`${t("CourierDashboardFilter")}: ${order.courierName}`}
                                onClick={() => onFilterCourier({id: order.courierProfileId, name: order.courierName})}>
                                <FilterAltOutlined fontSize="small"/>
                            </IconButton>
                        </Tooltip>
                    </Box></TableCell>
                    <TableCell>{order.pharmacyName}</TableCell>
                    <TableCell>{order.status === "CANCELLED" ? <Chip size="small" label={t("Cancelled")}/> : <DeliveryProgressChip status={order.status}/>}</TableCell>
                    <TableCell>{order.orderDate ? new Date(order.orderDate).toLocaleString(i18n.language) : "—"}</TableCell>
                    <TableCell>{order.productCount}</TableCell>
                    <TableCell><Box sx={{whiteSpace: "nowrap"}}>{Number(order.totalPrice).toLocaleString(i18n.language)} ֏</Box></TableCell>
                </TableRow>)}</TableBody>
            </Table></TableContainer>}
        <DashboardPagination data={data} {...pagination}/>
    </ContentContainer>;
}
